export type SearchResultDisplayData = {
  id: string;
  title: string;
  documentType: string;
  url: string;
  originalRecord: SearchResult;
  tooltipMetadata?: Record<string, string>;
};

export enum DocumentType {
  All = "ALL",
  Budgets = "BUDGETS",
  Proposals = "PROPOSALS",
  Worksheets = "WORKSHEETS",
  Stories = "STORIES",
  Reports = "REPORTS",
  Workforce = "WORKFORCE",
}

export enum SearchResultType {
  Budget = "BudgetSearchResult",
  Proposal = "ProposalSearchResult",
  Worksheet = "WorksheetSearchResult",
  AdjustmentLine = "AdjustmentLineSearchResult",
  Story = "StorySearchResult",
  Publication = "PublicationSearchResult",
  ClassicReport = "ClassicReportSearchResult",
  NextGenStandardReport = "NextGenStandardReportSearchResult",
  NextGenCustomReport = "NextGenCustomReportSearchResult",
  Workforce = "WorkforceSearchResult",
}

export enum LedgerType {
  Expenses = "EXPENSES",
  Revenues = "REVENUES",
}

export type BudgetSearchResultRecord = {
  id: string;
  __typename: SearchResultType.Budget;
  budgetId: number;
  name: string;
  subdomain: string;
};

export type ProposalSearchResultRecord = {
  id: string;
  __typename: SearchResultType.Proposal;
  proposalId: number;
  name: string;
  subdomain: string;
  budgetId: number;
  budgetName: string;
};

export type WorksheetSearchResultRecord = {
  id: string;
  __typename: SearchResultType.Worksheet;
  worksheetId: number;
  name: string;
  subdomain: string;
  budgetId: number;
  budgetName: string;
  proposalId: number;
  proposalName: string;
  ledgerType: LedgerType;
  hasLinkedWorkforce?: boolean;
};

export type AdjustmentLineSearchResultRecord = {
  id: string;
  __typename: SearchResultType.AdjustmentLine;
  subdomain: string;
  budgetId: number;
  budgetName: string;
  proposalId: number;
  proposalName: string;
  worksheetId: number;
  worksheetName: string;
  ledgerType: LedgerType;
  hasLinkedWorkforce?: boolean;
  displayAccountString: string;
};

export type WorkforceSearchResultRecord = {
  id: string;
  __typename: SearchResultType.Workforce;
  workforceId: string;
  name: string;
  subdomain: string;
  positionGroup: string;
  startDate: string;
  endDate: string;
};

export type StorySearchResultRecord = {
  id: string;
  __typename: SearchResultType.Story;
  storyId: number;
  name: string;
  subdomain: string;
  publicationId?: string;
  publicationTitle?: string;
};

export type PublicationSearchResultRecord = {
  id: string;
  __typename: SearchResultType.Publication;
  publicationId: number;
  name: string;
  subdomain: string;
};

export type ClassicReportSearchResultRecord = {
  id: string;
  __typename: SearchResultType.ClassicReport;
  classicReportId: number;
  name: string;
  subdomain: string;
};

export type NextGenCustomReportSearchResultRecord = {
  id: string;
  __typename: SearchResultType.NextGenCustomReport;
  nextGenReportId: number;
  name: string;
  subdomain: string;
};

export type NextGenStandardReportSearchResultRecord = {
  id: string;
  __typename: SearchResultType.NextGenStandardReport;
  standardReportId: string;
  lensId: string;
  name: string;
  subdomain: string;
};

export type SearchResult =
  | BudgetSearchResultRecord
  | ProposalSearchResultRecord
  | WorksheetSearchResultRecord
  | AdjustmentLineSearchResultRecord
  | WorkforceSearchResultRecord
  | StorySearchResultRecord
  | PublicationSearchResultRecord
  | ClassicReportSearchResultRecord
  | NextGenCustomReportSearchResultRecord
  | NextGenStandardReportSearchResultRecord;
